import ReportActions, {
    ReportActionsBox,
    SaveTemplateButton,
    AnalyzeButton,
    CompareReportsButton,
    CalcReportManualButton,
    CalcReportBackgroundButton
} from "./report-actions.jsx";

export {
    ReportActionsBox,
    SaveTemplateButton,
    AnalyzeButton,
    CompareReportsButton,
    CalcReportManualButton,
    CalcReportBackgroundButton
};

export default ReportActions;
